// src/components/common/Loader.js
import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

const Loader = ({ loading }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(loading);
  }, [loading]);

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255,255,255,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
        transition: "opacity 0.3s ease",
      }}
    >
      <Box
        className="rosary-loader"
        sx={{
          position: "relative",
          width: 70,
          height: 70,
        }}
      >
        {[...Array(8)].map((_, i) => (
          <Box
            key={i}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: 6,
              height: 6,
              margin: "-6px",
              borderRadius: "50%",
              background: "linear-gradient(45deg, #3b82f6, #1e40af)",
              transform: `rotate(${(360 / 8) * i}deg) translate(25px)`,
              animation: `rosary-spin 1.2s linear infinite`,
              animationDelay: `${i * 0.12}s`,
            }}
          />
        ))}
      </Box>

      <style>
        {`
          @keyframes rosary-spin {
            0% { opacity: 0.2; transform: scale(0.9) rotate(0deg) translate(25px); }
            50% { opacity: 1; transform: scale(1.2) rotate(180deg) translate(25px); }
            100% { opacity: 0.2; transform: scale(0.9) rotate(360deg) translate(25px); }
          }
        `}
      </style>
    </Box>
  );
};

export default Loader;
